import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FilterListComponent } from 'gung-list';
import { CartService, MetadataService, Product, ProductListByIdsConfigService, ProductService } from 'gung-standard';
import { CarLinerBrochuresProductListByIdsConfigService } from '../../services/car-liner-brochures-product-list-by-ids-config.service';
import { Subject, debounceTime, distinctUntilChanged, takeUntil } from 'rxjs';
import { CarLinerBrochuresHelperService } from '../../services/car-liner-brochures-helper.service';

@Component({
    selector: 'car-liner-brochures-add-modal',
    templateUrl: './car-liner-brochures-add-modal.component.html',
    styleUrls: ['./car-liner-brochures-add-modal.component.scss'],
    standalone: false
})
export class CarLinerBrochuresAddModalComponent implements OnInit, OnDestroy {

  @ViewChild('productList') productList: FilterListComponent<Product>;
  
  @Input()
  set productIds(ids: string[]) {
    this.configService.setSubscriptionIds(ids);
  }

  private _product: Product;
  @Input()
  set product(product: Product) {
    this._product = product;
    this.carLinerBrochuresHelperService.setProductId(product.id);
  }

  @Input()
  maxQty: number;
  currentQty: number = 0;
  blockedProducts: string[];

  searchTerm = '';
  protected searchTermUpdate: Subject<string> = new Subject<string>();

  unsubscribe: Subject<boolean> = new Subject<boolean>();

  constructor(
    public activeModal: NgbActiveModal,
    public configService: CarLinerBrochuresProductListByIdsConfigService,
    protected productService: ProductService,
    protected cartService: CartService,
    protected carLinerBrochuresHelperService: CarLinerBrochuresHelperService
  ) {
  }

  ngOnInit() {
    // The config service is providedIn: 'root', so the search term survives between openings
    this.configService.setSearchTerm('');
    this.searchTermUpdate
      .pipe(debounceTime(300), distinctUntilChanged(), takeUntil(this.unsubscribe))
      .subscribe(term => this.configService.setSearchTerm(term));

    this.cartService.getCurrentCart().pipe(takeUntil(this.unsubscribe)).subscribe(cart => {
      this.currentQty = 0;
      this.blockedProducts = [];
      for (const cartRow of cart) {
        if (cartRow.productPartialId === ('artv_' + this._product.id)) {
          if (cartRow.qty >= this.maxQty) {
            if (!this.blockedProducts.includes(cartRow.productId)) {
              this.blockedProducts.push(cartRow.productId);
            }
          } else {
            const index = this.blockedProducts.indexOf(cartRow.productId);
            if (index !== -1) {
              this.blockedProducts.splice(index, 1);
            }
          }
        }
      }
      // Must be published outside the loop. When the last manual row is removed there is no
      // matching cartRow left, the loop never enters the if, and subscribers keep the stale
      // blocked list -- which left the plus button greyed out.
      this.carLinerBrochuresHelperService.setBlockAddProduct(this.blockedProducts);
    });
  }

  onSearchTermChange(term: string) {
    this.searchTerm = term;
    this.searchTermUpdate.next(term);
  }

  ngOnDestroy() {
    this.configService.setSearchTerm('');
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
    this.carLinerBrochuresHelperService.clearHelper();
  }
}
